export const GET_REVIEWS = 'Get_Reviews';